import publicApi from "../../publicApi";

export const ordersService = {
  createOrder: async (payload) => {
    const res = await publicApi.post("/orders", payload);
    return res.data;
  },
};
